// src/components/TabPanel/TabPanel.js
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { combineClasses, updateParams } from "@/lib/utils";
import styles from "./TabPanel.module.scss";

const TabPanel = ({ tabNames = [], className = "" }) => {
  const [params, setParams] = useSearchParams();
  const currentTab = params.get("tab") ?? "0";

  const handleTabChange = (index) => {
    updateParams({ tab: index }, setParams);
  };

  useEffect(() => {
    if (currentTab === null) {
      handleTabChange(0);
    }
  }, []);

  return (
    <div className={combineClasses(styles.tabPanel, className)}>
      {tabNames.map((label, idx) => (
        <span
          key={idx}
          className={combineClasses(
            styles.tabName,
            currentTab === String(idx) ? styles.active : ""
          )}
          onClick={() => handleTabChange(idx)}
        >
          {label}
        </span>
      ))}
    </div>
  );
};

export default TabPanel;
